export const riskCategoryTableColumns = [
    { id: "minAuditedLtv", label: "Min Audited Ltv" },
    { id: "maxAuditedLtv", label: "Max Audited Ltv" },
    { id: "auditLtvScore", label: "Audited Ltv Score" },
  ];
export const riskCategoryMarketLtvTableColumns = [
    { id: "minMarketLtv", label: "Min Market Ltv" },
    { id: "maxMarketLtv", label: "Max Market Ltv" },
    { id: "marketLtvScore", label: "Market Ltv Score" },
  ];
export const riskCategoryDpdTableColumns = [
    { id: "minDpd", label: "Min Dpd" },
    { id: "maxDpd", label: "Max Dpd" },
    { id: "dpdScore", label: "Dpd Score" },
    { id:"action", label: "Action"},
  ];

export const riskCategoryScoreTableColumns = [
    { id: "riskCategory", label: "Risk Category" },
    { id: "minAuditedLtv", label: "Min Score" },
    { id: "maxAuditedLtv", label: "Max Score" },
    { id: "action", label: "Actions" },
  ];
  
  export const riskCategoryAndWeightageTableColumns = [
    {id:"base",label:"Parameter"},
    {id:"min",label:"Min"},
    {id:"max",label:"Max"},
    {id:"score",label:"Score (MAX 100)"},
    { id: "action", label: "Actions" },
]
  export const riskCategoryWeightageTableColumns = [
    {id:"base",label:"Parameter"},
    {id:"weightage",label:"Weight Percentage(%)"},
]

export  const riskCategoryList = [
     "LOW",
     "MODERATE",
     "AVERAGE",
     "HIGH",
  ];
export  const riskWeightageList = [
  { code: "AUDIT_LTV", name: "Audited LTV" },
  { code: "MARKET_LTV", name: "Market LTV" },
  { code: "DPD", name: "DPD" },
  ];

  export const masterNames = {
    masterList:"Master List",
    goldRateMaster: "Gold Rates",
    branchesMaster: "Branches",
    pincodesMaster:"Pincodes",
    loanSchemeMaster:"Loan Scheme",
    inviteUserMaster:"Invite User",
    stateMaster:"State",
    roleMaster:"Role",
    designationMaster:"Designation",
    structureMaster:"Structure",
    hierarchyMaster:"Hierarchy",
    ornamentMaster:"Ornament",
    standardDeductionMaster:"Standard Deduction",
    noticeBoardMaster:"Notice Board",
    registerMaster:"Register Master",
    packetInventoryMaster:"Packet Inventory",
    lenderMaster:"Lender Master-BT",
    relationshipMaster:"Relationship Master",
    negativeProfileMaster:"Negative Profile Master",
    discrepancyMaster:"Discrepancy Master",
    collateralValuationMaster:"Collateral Valuation Master",
    riskCategoryMaster:"Risk Category Master",
    riskCategoryScoreMaster:"Risk Category Score Master",
    insuranceMaster: "VAP",
    inuranceMasterChild1:"Sum Insured",
    inuranceMasterChild2:"Insurance Eligibility",
    thirdPartyMaster:"Third Party Master",
    holidayMaster:"Holiday Master",
    glHeadMaster:"GL-Head Master",
    whiteListIpMaster:"White List IP Master",
    accessRestriction:"Access Restriction",
    coLendingMaster: "CO-Lending Master",
    lendingMaster:"Colender Master",
    lendingPartnerDeal:"Lending Partner Deal",
    lendingPartnerDealShare:"Lending Partner Deal Share",
    renewalTopUpValidation:"Renewal Top-Up Validation Master",
    deviationMaster:"Deviation Master",
    leadValidationMaster: "Lead Validation Master",
    negativeRegistry: "Negative Registry Master",
    masterCategoryList: "Master Category List",
    foirMaster:"FOIR Master",
    foirMasterCode:"FOIR_MASTER",
    foirMasterUrl:"/coreservice/foirConfig",
  };

export const actions = {
  success:"SUCCESS",
  error:"ERROR"
};

export const riskCategoryAndWeightageDeleteDataColumns = [
  {id:"base",label:"Parameter"},
  {id:"min",label:"Min"},
  {id:"max",label:"Max"},
  {id:"score",label:"Score (MAX 100)"},
];

export const riskCategoryAuditLtv = {
  auditLtvName:"Audit LTV",minAuditedLtv : "minAuditedLtv", maxAuditedLtv : "maxAuditedLtv", auditLtvScore : "auditLtvScore"
};

export const riskCategoryMarketLtv = {
  marketLtvName:"Market LTV",minMarketLtv:"minMarketLtv", maxMarketLtv:"maxMarketLtv", marketLtvScore:"marketLtvScore"
};

export const riskCategoryDpd = {
  dpdName:"DPD",minDpd:"minDpd", maxDpd:"maxDpd", dpdScore:"dpdScore"
};

export const actionText = {
  delete:"delete",
  edit: "edit",
};

export const sumInsured = [
  { id: "minAge", label: "Min Age" },
  { id: "maxAge", label: "Max Age" },
  { id: "sumInsured", label :"Sum Insured"},
  { id: "action", label: "Action"}
];

export  const insuranceEligibilityColumns = [
  { id: "minAge", label: "Min Age(Year)" },
  { id: "maxAge", label: "Max Age(Year)" },
  { id: "minBMI", label :"Min BMI"},
  { id: "maxBMI", label :"Max BMI"},
  { id: "minLoanAmt", label :"Min  Loan Amount"},
  {id: "maxLoanAmt", label: "Max Loan Amount"},
  {id: "action", label: "Action"},
];

export const customerEligibilityData = [
  { code: "Age", name: "Age" },
  { code: "Bmi", name: "Bmi" },
  { code: "Loan Amount", name: "Loan Amount" },
];
export const activeServiceData =  [
  { code: "true", name: "YES" },
  { code: "false", name: "NO" },
]

export  const thirdPartyColumnsData = [
  { id: "index", label: "S. No." },
  { id: "integration", label: "Integrations" },
  { id: "enabled", label :"Enabled"},
  { id: "vendor", label :"Vendor"},
  {id: "action", label: "Actions"}
];

export const holidayTableColumns = [
    { id: "date", label: "Date" },
    { id: "description", label: "Description" },
];

export const criteriaBaseData = [
    {name:"NEW_LOAN_AMT",type:"New Amount"},
    {name:"OLD_LOAN_AMT",type:"Old Amount"},
    {name:"LOAN_AMT_DIFFERENCE",type:"Difference"},
]

export const commonButton={
  button1: "Save",
  button2: "Cancel"
}

export const toastAction={
  success:"Success",
  error: "Error"
}

export const goldRateData={
  label:"Gold Rate",
  button:"Edit Gold Rate",
  tableColumns: [
    { id: "fitnesscode", label: "Fineness Code" },
    { id: "leadingrate", label: "Lending Rate" },
    { id: "marketrate", label: "Market Rate" },
  ],
  successMsg:"Create GoldRate successfully",
  lendingRateError:"Lending Rate should be smaller than or equal to the existing rate",
  createUrl:"/coreservice/gold-rates-create",
  mainUrl:"/coreservice/gold-rates"
}

export const branchData={
  label:"Branches",
  searchLabel:"Search For Branch",
  delBranchSuccess:"Delete Branch is successful",
  delConfirmation:"Are you sure you want to delete this entry",
  mainUrl:"/coreservice/branch-create/",
  viewUrl:"/coreservice/branch-view/",
  noExist: "No Branch exists",
  delConfirmationHeader:"Branch",
  tableColumns:[
    { id: "branchcode", label: "Branch Code" },
    { id: "branchname", label: "Branch Name" },
    { id: "branchtype", label: "Branch Type" },
    { id: "phone", label: "Phone Number" },
    { id: "address", label: "Address" },
    { id: "state", label: "State" },
    { id: "city", label: "City" },
    { id: "pincode", label: "Pincode" },
  ]
}

export const pinCodeData={
  label:"Pincode",
  button:"Create PinCode",
  searchLabel:"Search For PinCode",
  createLabel:"Create Pincode",
  tableColumns:[
    { id: "pincode", label: "PinCodes" },
    { id: "branchname", label: "Branch Name" },
    { id: "action", label: "Actions" },
  ],
  createUrl:"/coreservice/pincode-create",
  confirmationMsg:"Are you sure you want to unlink pincode from this branch",
  unlinkConfirmationHeader:"Unlink Pincode",
  mainUrl:"/coreservice/pincodes",
  successMsg:"Created Pincode successfully",
  notLinked:"Pincode not linked to any branch.",
  unLinkedSuccess:"Pincode is successfully unlinked from Branch",
  delConfirmationMsg:"Are you sure you want to delete this entry",
  delSuccess:"Delete Pincode is successful"
}

// userConfig.js
export const userDataConfig = {
  label: "User & Roles",
  button: "Invite User",
  searchLabel: "Search For User",
  createUrl: "/coreservice/user-roles-invite",
  viewUrl: "/coreservice/user-roles-invite-createview/",
  updateUrl: "/coreservice/user-roles-invite/",
  confirmationHeader: "User & Role",
  confirmationMsg: "Are you sure you want to delete this entry",
  successMsg: "Delete User is successful",
  tableColumnsRole: [
    { id: "name", label: "Name" },
    { id: "employeId", label: "Employee Id" },
    { id: "email", label: "Email" },
    { id: "mobilenumber", label: "Mobile Number" },
    { id: "role", label: "Role" },
    { id: "branch", label: "Branch Name" },
    { id: "active", label: "Active" },
    { id: "actions", label: "Actions" },
  ],
  tableColumnsDesignation: [
    { id: "name", label: "Name" },
    { id: "employeId", label: "Employee Id" },
    { id: "email", label: "Email" },
    { id: "mobilenumber", label: "Mobile Number" },
    { id: "role", label: "Designation" },
    { id: "branch", label: "Branch Name" },
    { id: "active", label: "Active" },
    { id: "actions", label: "Actions" },
  ],
  createSuccess:"Created User Successfully",
  mainUrl:"/coreservice/user-roles",
  emailError:"Email must contain one of the following domains:",
  viewLabel:"View Invite User",
  updateUser:"Updated User Successfully"
};

export const glHeadTableColumns = [
    { id: "name", label: "Structure Code" },
    { id: "code", label: "GL Code" },
    { id: "description", label: "Description" },
    { id: "action", label: "Actions" },
  ];

export const glHeadMasterData = {
  goldLoan:"Gold Loan",
  label:"GL-Head",
  buttonLabel:"Create GL-Head",
  createLink:"/coreservice/GLHead-create",
  arialLabel:"Edit GL-Head",
  editLink:"/coreservice/GLHead-edit",
}

export const glHeadLists = [
  "CASH_ON_HAND",
  "BANK_ACCOUNT",
  "LOAN",
  "PRINCIPAL",
  "INTEREST",
  "INTEREST_RECEIVED",
  "INTEREST_SUSPENSE",
  "ACCURED_INTEREST",
  "CASH_CONTROL_ACCOUNT",
  "IGST_COLLECTED",
  "SGST_COLLECTED",
  "CGST_COLLECTED",
  "WRITEOFF",
  "PAYABLE",
  "BT_ADVANCE",
  "BT_ADVANCE_CONTROL",
  "CASH_DISBURSAL_CHARGE_RECOVERED",
  "CUSTUDY_CHARGE_RECOVERED",
  "FORECLOSURE_CHARGE_RECOVERED",
  "PAWN_REISSUE_CHARGE_RECOVERED",
  "PREPAYMENT_CHARGE_RECOVERED",
  "PROCESS_FEE_CHARGE_RECOVERED",
  "STAMP_DUTY_CHARGE_RECOVERED",
  "MEMO_CHARGE_RECOVERED",
  "POSTAL_CHARGE_RECOVERED",
  "CHECK_BOUNCE_CHARGE_RECOVERED",
  "ADVERTISEMENT_CHARGE_RECOVERED",
  "AUCTION_CHARGE_RECOVERED",
  "OTHER_CHARGE_RECOVERED",
  "PENAL_CHARGE_RECOVERED",
  "INTER_LOAN_TRANSFER_CONTROL",
  "REBATE",
  "WAIVER",
  "COLLECTION_CONTROL_ACCOUNT",
  "DISBURSEMENT_CONTROL_ACCOUNT",
  "COLLECTION_BANK_ACCOUNT",
  "PROVISION_STANDARD_ASSETS",
  "PROVISION_SUB_STANDARD_ASSETS",
  "PROVISION_DOUBTFUL_ASSETS",
  "PROVISION_LOSS_ASSETS",
  "PROVISION_STANDARD_ASSETS_EXPENSES",
  "PROVISION_SUB_STANDARD_ASSETS_EXPENSES",
  "PROVISION_DOUBTFUL_ASSETS_EXPENSES",
  "PROVISION_LOSS_ASSETS_EXPENSES",
  "PHOTOCOPY_DOCUMENT_CHARGE_RECOVERED",
  "RECOVERY_CHARGE_RECOVERED",
  "RENEWAL_CHARGE_RECOVERED",
  "DUPLICATE_NO_DUES_CERTIFICATE_CHARGE_RECOVERED",
  "FORECLOSURE_STATEMENT_CHARGE_RECOVERED",
  "ORIGINAL_DOCUMENT_RETRIEVAL_CHARGE_RECOVERED",
  "BAD_DEBTS_RECOVERED",
  "CHARGE_WAIVER",
  "MTM_CHARGE_RECOVERED",
  "LOAN_MODIFICATION_CHARGE_RECOVERED",
  "DOCUMENT_LIST_CHARGE_RECOVERED",
  "COLLATERAL_RETRIEVAL_CHARGE_RECOVERED",
  "COLLATERAL_HANDLING_CHARGE_RECOVERED",
  "DUPLICATE_CLOSURE_LETTER_CHARGE_RECOVERED",
  "COLLATERAL_CHARGE_RECOVERED",
  "BALANCE_STATEMENT_CHARGE_RECOVERED",
  "INTEREST_INCOME_RECEIVABLE_NPA",
  "LOAN_CANCELLATION_CHARGE_RECOVERED",
  "PENAL_CHARGE_INCOME_ON_PRINCIPAL_NON_GST",
  "AUCTION_SURPLUS_REFUNDABLE",
  "REFUND_CONTROL_ACCOUNT",
  "OTHER_RECEIVABLES",
  "INTEREST_RECEIVABLE_NPA",
  "INSTALLMENT_RECEIVABLE_NPA",
  "LOAN_NPA"
];
export const coledingGlList = [
  "COLENDING_ACCOUNT",
  "COLENDING_CONTRA", 
  "COLENDING_ESCROW_COLLECTION",
  "COLENDING_ESCROW_DISBURSAL", 
  "COLENDING_PARTNER_SHARE",
  "COLENDING_INTEREST_RECEIVED",
]

export const whiteListIPConfig = {
  label: "White List IP",
  button: "Create",
  searchLabel: "Search For White List IP",
  createUrl: "/coreservice/WhiteListIP-create",
  updateUrl: "/coreservice/WhiteListIP-create/",
  confirmationHeader: "White List IP",
  confirmationMsg: "Are you sure you want to delete this entry",
  successMsg: "Whitelist IPs deleted successfully",
  tableColumns: [
    { id: "index", label: "S. No." },
    { id: "branchName", label: "Branch Name" },
    { id: "enabled", label :"Enabled"},
    { id: "whitelistIp", label :"WhiteList IP's"},
    { id: "action", label: "Actions"}
  ],
  createSuccess:"White List IP created successfully!",
  editSuccess:"White List IP edited successfully!",
  mainUrl:"/coreservice/WhiteListIP",
  createLabel:"Create White List IP",
  updateUser:"Edit White List IP"
};

export const structureMasterTableColumns = [
  { id: "code", label: "Type Code" },
  { id: "name", label: "Name" },
  { id: "parentCode", label: "Parent Code" },
  { id: "action", label: "Actions" },
];

export const accessRestrictionConfig = {
  label: "Asset Restriction",
  button: "Create",
  searchLabel: "Search For Asset Restriction",
  createUrl: "/coreservice/AccessRestriction-create",
  updateUrl: "/coreservice/AccessRestriction-edit/",
  confirmationHeader: "Asset Restriction",
  confirmationMsg: "Are you sure you want to delete this entry",
  successMsg: "Whitelist IPs deleted successfully",
  tableColumns: [
    { id: "index", label: "S. No." },
    { id: "designation", label: "Designation Name" },
    { id: "role", label :"Role Name"},
    { id: "name", label :"Name"},
    { id: "disabled", label :"Disabled"},
    { id: "action", label: "Actions"}
  ],
  createSuccess:"Asset Restriction created successfully!",
  editSuccess:"Asset Restriction edited successfully!",
  mainUrl:"/coreservice/AccessRestriction",
  createLabel:"Create Asset Restriction",
  updateUser:"Edit Asset Restriction"
};

export const coreList = {
  goldRateMaster: { name: "Gold Rates", code: "GOLDRATE", disabled: true },
  branchesMaster: { name: "Branches", code: "BRANCHES", disabled: true },
  pincodesMaster: { name: "Pincodes", code: "PINCODES", disabled: true },
  loanSchemeMaster: { name: "Loan Scheme", code: "LOANSCHEME", disabled: true },
  inviteUserMaster: { name: "Invite User", code: "INVITEUSER", disabled: true },
  stateMaster: { name: "State", code: "STATE", disabled: true },
  roleMaster: { name: "Role", code: "ROLE", disabled: true },
  designationMaster: { name: "Designation", code: "DESIGNATION", disabled: true },
  structureMaster: { name: "Structure", code: "STRUCTURE", disabled: true },
  hierarchyMaster: { name: "Hierarchy", code: "HIERARCHY", disabled: true },
  ornamentMaster: { name: "Ornament", code: "ORNAMENT", disabled: true },
  standardDeductionMaster: { name: "Standard Deduction", code: "STANDARDDEDUCTION", disabled: true },
  noticeBoardMaster: { name: "Notice Board", code: "NOTICEBOARD", disabled: true },
  registerMaster: { name: "Register Master", code: "REGISTER", disabled: true },
  packetInventoryMaster: { name: "Packet Inventory", code: "PACKETINVENTORY", disabled: true },
  lenderMaster: { name: "Lender Master-BT", code: "LENDER", disabled: true },
  relationshipMaster: { name: "Relationship Master", code: "RELATIONSHIP", disabled: true },
  negativeProfileMaster: { name: "Negative Profile Master", code: "NEGATIVEPROFILE", disabled: true },
   negativeRegistryMaster: { name: "Negative Registry Master", code: "NEGATIVEREGISTRY", disabled: true },
  discrepancyMaster: { name: "Discrepancy Master", code: "DISCREPANCY", disabled: true },
  collateralValuationMaster: { name: "Collateral Valuation Master", code: "COLLATERALVALUATION", disabled: true },
  riskCategoryMaster: { name: "Risk Category Master", code: "RISKCATEGORY", disabled: true },
  insuranceMaster: {
    name: "VAP",
    code: "VAP",
    disabled: true,
    children: {
      inuranceMasterChild1: {
        name: "Sum Insured",
        code: "VAP_SUMINSURED",
        disabled: true,
      },
      inuranceMasterChild2: {
        name: "Insurance Eligibility",
        code: "VAP_ELIGIBILITY",
        disabled: true,
      },
    },
  },
  thirdPartyMaster: { name: "Third Party Master", code: "THIRDPARTY", disabled: true },
  holidayMaster: { name: "Holiday Master", code: "HOLIDAY", disabled: true },
  glHeadMaster: { name: "GL-Head Master", code: "GLHEAD", disabled: true },
  whiteListIpMaster: { name: "White List IP Master", code: "WHITELISTIP", disabled: true },
  renewalTopUpValidation: { name: "Renewal Top-Up Validation Master", code: "RENEWAL_TOP_UP_VALIDATION", disabled: true },
  deviationMaster: { name: "Deviation Master", code: "DEVIATION_MASTER", disabled: true },
  leadValidationMaster: { name: "Lead Validation Master", code: "LEAD_VALIDTION_MASTER", disabled: true },
  masterCategoryList: { name: "Master Category", code: "MASTER_CATEGORY", disabled: true },
  foirMaster: { name: "FOIR Master", code: "FOIR_MASTER", disabled: true },
  partnerMaster: {
    name: "Colender Master",
    code: "CO_LENDING_MASTER",
    disabled: true,
    children: {
      partnerMasterChild1: {
        name: "Lending Partner",
        code: "LENDING_PARTNER",
        disabled: true,
      },
       partnerMasterChild2: {
        name: "Partner Deal",
        code: "PARTNER_DEAL",
        disabled: true,
      },
       partnerMasterChild3: {
        name: "Partner Deal Share",
        code: "PARTNER_DEAL_SHARE",
        disabled: true,
      },
    },
  },
};

 export const losList = {
  dashboard: {
    name: "Dashboard",
    code: "DASHBOARD",
    disabled: true,
  },
  application: {
    name: "Application",
    code: "APPLICATION",
    disabled: true,
    children: {
      inProcess: { name: "In Process", code: "IN_PROCESS", disabled: true },
      inProcessV2: { name: "Credit Appraisal", code: "IN_PROCESS_V2", disabled: true },
      submitted: { name: "Submitted", code: "SUBMITTED", disabled: true },
      preApproval: {
        name: "Pre Sanction Approval",
        code: "PRE_SANCTION_APPROVAL",
        disabled: true,
      },
      deviationApproval:{
        name: "Deviation Approval",
        code: "DEVIATION_APPROVAL",
        disabled: true,
      },
      collateralDiscrepancy:{
        name: "Collateral Discrepancy Approval",
        code: "COLLATERAL_DISCREPANCY_APPROVAL",
        disabled: true,
      },
      discrepancyApprovale:{name:"Discrepancy Approval", code:"DISCREPANCY_APPROVAL", disabled:true},
      collateralValuation: {
        name: "Collateral Valuation Approval",
        code: "COLLATERAL_VALUATION",
        disabled: true,
      },
      forApproval: {
        name: "For Approval",
        code: "FOR_APPROVAL",
        disabled: true,
      },
      disbursal: { name: "Disbursal", code: "DISBURSAL", disabled: true },
      disburseToLms: {
        name: "Disburse To LMS",
        code: "DISBURSE_TO_LMS",
        disabled: true,
      },
      completed: { name: "Completed", code: "COMPLETED", disabled: true },
      rejected: { name: "Rejected", code: "REJECTED", disabled: true },
      personalLoan: {
        name: "Personal Loan",
        code: "PERSONAL_LOAN",
        disabled: true,
      },
    },
  },
  leadReports: {
    name: "Lead Reports",
    code: "LEAD_REPORTS",
    disabled: true,
  },
  reports: {
    name: "Reports",
    code: "REPORTS",
    disabled: true,
  },
  rejectApplication: {
    name: "Reject Application",
    code: "REJECT_APPLICATION",
    disabled: true,
  },
  criffCalculator: {
    name: "Gold Loan Calculator",
    code: "CRIFF_CALCULATOR",
    disabled: true,
  },
  maskedDocumentNumber: {
    name: "Show Masked Data",
    code: "MASKED_DATA_LOS",
    disabled: true,
  },
};


export const lmsList = {
  DASHBOARD: {
    name: "Dashboard",
    code: "DASHBOARD",
    disabled: true,
  },
  MASKED_DATA_LMS: {
    name: "Show Masked Data",
    code: "MASKED_DATA_LMS",
    disabled: true,
  },
  DOWNLOAD_BRANCH_REPORT: {
    name: "Download Branch Report Access",
    code: "DOWNLOAD_BRANCH_REPORT_ACCESS",
    disabled: true,
  },
  COLLATERAL_AS_PER_AUDITED: {
        name: "Collateral As per Audited",
        code: "COLLATERAL_AS_PER_AUDITED",
        disabled: true,
  },
  CUSTOMER_MODULE: {
    name: "Customer Module",
    code: "CUSTOMER_MODULE",
    disabled: true,
  },
  VIRTUAL_ACCOUNT_SIDEBAR: {
    name: "Virtual Account",
    code: "VIRTUAL_ACCOUNT_SIDEBAR",
    disabled: true,
  },
  MAKER_MODULE: {
    name: "Maker Module",
    code: "MAKER_MODULE",
    disabled: true,
    children: {
      RECEIPTS_PAYMENTS: {
        name: "Receipts & Payments",
        code: "MAKER_RECEIPTS_PAYMENTS",
        disabled: true,
        children: {
          RECEIPT: {
            name: "Receipt",
            code: "MAKER_RECEIPT",
            url: "/lmsservice/makermodule/receipt",
            disabled: true,
          },
          CANCEL_RECEIPT: {
            name: "Cancel Receipt",
            code: "MAKER_CANCEL_RECEIPT",
            url: "/lmsservice/makermodule/cancelreceipt",
            disabled: true,
          },
          RECEIPT_PART_B: {
            name: "Receipt",
            code: "MAKER_RECEIPT_PART_B",
            url: "/lmsservice/makermodule/receiptPartb",
            disabled: true,
          },
          CANCEL_RECEIPT_PART_B: {
            name: "Cancel Receipt",
            code: "MAKER_CANCEL_RECEIPT_PART_B",
            url: "/lmsservice/makermodule/cancelReceiptPartb",
            disabled: true,
          },
          PAYMENT: {
            name: "Payment",
            code: "MAKER_PAYMENT",
            url: "/lmsservice/makermodule/payment",
            disabled: true,
            children:{
              PAYBLE_PAYMENT:{
                name:"Payable",
                code:"MAK_PAYMENT_CASH",
                disabled:true,
              },
              CANCEL_PAYMENT:{
                name:"Cancel",
                code:"MAK_PAYMENT_CANCEL",
                disabled:true,
              },
            },
          },
        },
      },
      CHARGES: {
        name: "Charges",
        code: "MAKER_CHARGES",
        disabled: true,
        children: {
          ENTRY: {
            name: "Entry",
            code: "MAKER_ENTRY",
            url: "/lmsservice/makermodule/entry",
            disabled: true,
          },
          CANCELLATION: {
            name: "Cancellation",
            code: "MAKER_CANCELLATION",
            url: "/lmsservice/makermodule/Cancellation",
            disabled: true,
          },
          WAIVE_OFF: {
            name: "Waive off",
            code: "MAKER_WAIVE_OFF",
            url: "/lmsservice/makermodule/waiveoff",
            disabled: true,
          },
          NEW_WAIVE_OFF: {
            name: "Waive off",
            code: "MAKER_NEW_WAIVE_OFF",
            url: "/lmsservice/makermodule/newwaiveoff",
            disabled: true,
          },
           NEW_WAIVE_OFF_CANCEL: {
            name: "Waive off Cancel",
            code: "MAKER_NEW_WAIVE_OFF_CANCEL",
            url: "/lmsservice/makermodule/newwaiveoffCancel",
            disabled: true,
          },
        },
      },
      ASSET: {
        name: "Asset",
        code: "MAKER_ASSET",
        disabled: true,
        children: {
          COLLATERAL_OPERATION: {
            name: "Collateral Operation",
            code: "MAKER_COLLATERAL_OPERATION",
            url: "/lmsservice/makermodule/CollateralOperation",
            disabled: true,
          },
          BRANCH_KEY_HOLDER: {
            name:"Branch Key Holder",
            code:"MAK_BRANCH_KEY_HOLDER",
            url:"/lmsservice/makermodule/BankKeyHolderUpdate",
            disabled:true,
          },
          VALUT_UPDATE:{
            name: "Vault Update",
            code:"MAK_VALUT_UPDATE",
            url:"/lmsservice/makermodule/vaultUpdate",
            disabled:true,
          }
        },
      },
      LOAN_MARKING: {
        name: "Loan Marking",
        code: "MAKER_LOAN_MARKING",
        disabled: true,
        children: {
          LOAN_MARKING_ACTION: {
            name: "Loan Marking",
            code: "MAKER_LOAN_MARKING_ACTION",
            url: "/lmsservice/makermodule/LoanMarking",
            disabled: true,
          },
          REMOVAL: {
            name: "Removal",
            code: "MAKER_REMOVAL",
            url: "/lmsservice/makermodule/Removal",
            disabled: true,
          },
        },
      },
      CLOSURE: {
        name: "Closure",
        code: "MAKER_CLOSURE",
        disabled: true,
        children: {
          CLOSURE_ACTION: {
            name: "Closure",
            code: "MAKER_CLOSURE_ACTION",
            url: "/lmsservice/makermodule/Closure",
            disabled: true,
          },
          CLOSURE_REMOVAL: {
            name: "Closure Removal",
            code: "MAKER_CLOSURE_REMOVAL",
            url: "/lmsservice/makermodule/ClosureRemoval",
            disabled: true,
          },
        },
      },
      POST_DISBURSAL_EDIT: {
        name: "Post Disbursal Edit",
        code: "MAKER_POST_DISBURSAL_EDIT",
        disabled: true,
        children: {
          LOAN_LINKING_DELINKING: {
            name: "Loan Linking/Delinking",
            code: "MAKER_LOAN_LINKING_DELINKING",
            url: "/lmsservice/makermodule/loandelinkandlink",
            disabled: true,
            children:{
              POST_LINKING: {
                name:"Link",
                code:"MAK_POST_LINK",
                disabled:true,
              },
              POST_DE_LINKING: {
                name:"DeLink",
                code:"MAK_POST_DELINK",
                disabled:true,
              },
            }
          },
          ADDRESS_UPDATE: {
            name: "Address Update",
            code: "MAKER_ADDRESS_UPDATE",
            url: "/lmsservice/makermodule/AddressUpdate",
            disabled: true,
          },
          CUSTOMER_UPDATE: {
            name: "Customer Update",
            code: "MAKER_CUSTOMER_UPDATE",
            url: "/lmsservice/makermodule/CustomerUpdate",
            disabled: true,
            children:{
              POST_CUSTOMER_INFO: {
                name:"Customer Info",
                code:"MAK_POST_INFO",
                disabled:true,
              },
              POST_CUSTOMER_COMMUNICATION: {
                name:"Communications",
                code:"MAK_POST_COMMUNICATION",
                disabled:true,
              },
              POST_CUSTOMER_MERGE: {
                name:"Customer merge",
                code:"MAK_POST_MERGE",
                disabled:true,
              },
            }
          },
          LOAN_INFO_UPDATE: {
            name: "Loan Info Update",
            code: "MAKER_LOAN_INFO_UPDATE",
            url: "/lmsservice/makermodule/CycleDateCreate",
            disabled: true,
             children:{
              POST_CYCLE_DATE: {
                name:"Cycle Date",
                code:"MAK_CYCLE_DATE",
                disabled:true,
              },
              POST_ACCURAL_INTEREST: {
                name:"Accural Interst",
                code:"MAK_POST_ACCURAL_INTEREST",
                disabled:true,
              },
              POST_SANCTION_LETTER: {
                name:"Sanction Letter",
                code:"MAK_POST_SANCTION_LETTER",
                disabled:true,
              },
              POST_RECTIFICATION: {
                name:"Rectification",
                code:"MAK_POST_RECTIFICATION",
                disabled:true,
              },
              POST_INSURANCE_LETTER: {
                name:"Insurance Letter",
                code:"MAK_POST_INSURANCE_LETTER",
                disabled:true,
              },
              POST_ORNAMENT_PHOTO: {
                name:"Ornament Photo",
                code:"MAK_POST_ORNAMENT_PHOTO",
                disabled:true,
              },
              INTEREST_DATE: {
                name:"Interest Date Update",
                code:"MAK_INTESTET_DATE_UPDATE",
                url:"/lmsservice/makermodule/interestDateUpdate",
                disabled:true,
              },
              PRINCIPLE_UPDATE: {
                name:"Principle Update",
                code:"MAK_PRINCIPLE_UPDATE",
                disabled:true,
              },
            }
          },
          PACKET_CHANGE: {
            name: "Packet Change",
            code: "MAKER_PACKET_CHANGE",
            url: "/lmsservice/makermodule/PacketChange",
            disabled: true,
          },
           REPORT_RECTIFICATION: {
            name: "Scheduler Report Upload",
            code: "MAKER_SCHEDULAR_REPORT_UPLOAD",
            url: "/lmsservice/makermodule/reportRectification",
            disabled: true,
          },
        },
      },
      AUCTION: {
        name: "Auction",
        code: "MAKER_AUCTION",
        disabled: true,
        children: {
          AUCTION_ACTION: {
            name: "Auction",
            code: "MAKER_AUCTION_ACTION",
            url: "/lmsservice/makermodule/Auction",
            disabled: true,
          },
        },
      },
      INSTRUMENT_ENTRY: {
        name: "Instrument Entry",
        code: "MAKER_INSTRUMENT_ENTRY",
        disabled: true,
        children: {
          BANK_DETAILS_UPDATE: {
            name: "Bank Details Update",
            code: "MAKER_BANK_DETAILS_UPDATE",
            url: "/lmsservice/makermodule/BankDetailsUpdate",
            disabled: true,
          },
          REPAYMENT_SCHEDULE: {
            name: "Repayment Schedule",
            code: "MAKER_REPAYMENT_SCHEDULE",
            url: "/lmsservice/makermodule/RepaymentSchedular",
            disabled: true,
          },
          MANDATE_UPDATE: {
            name: "Mandate Update",
            code: "MAKER_MANDATE_UPDATE",
            url: "/lmsservice/makermodule/mandateUpdate",
            disabled: true,
          },
        },
      },
      PDD: {
        name: "PDD",
        code: "MAKER_PDD",
        disabled: true,
        children: {
          PDD_CREATE: {
            name: "PDD Create",
            code: "MAKER_PDD_CREATE",
            url: "/lmsservice/makermodule/Pdd",
            disabled: true,
          },
          PDD_REMOVAL: {
            name: "PDD Removal",
            code: "MAKER_PDD_REMOVAL",
            url: "/lmsservice/makermodule/PddRemoval",
            disabled: true,
          },
        },
      },
      VIRTUALACCOUNTMAKER: {
        name: "Virtual Account",
        code: "MAKER_VIRTUAL_ACCOUNT",
        url: "/lmsservice/makermodule/virtualAccount",
        disabled: true,
      },
    },
  },
  CHECKER_MODULE: {
    name: "Checker Module",
    code: "CHECKER_MODULE",
    disabled: true,
    children: {
      RECEIPTS_PAYMENTS: {
        name: "Receipts & Payments",
        code: "CHECKER_RECEIPTS_PAYMENTS",
        disabled: true,
        children: {
          RECEIPT: {
            name: "Receipt",
            code: "CHECKER_RECEIPT",
            url: "/lmsservice/checkermodule/Receipt",
            disabled: true,
            children: {
              CASH_RECEIPT: {
                name:"CASH",
                code:"CHK_RECEIPT_CASH",
                disabled: true,
              },
              ELECTRONIC_RECEIPT: {
                name:"ELECTRONIC RECEIPT",
                code:"CHK_RECEIPT_ELECTRONIC",
                disabled: true,
              },
            },
          },
          CANCEL_RECEIPT: {
            name: "Cancel Receipt",
            code: "CHECKER_CANCEL_RECEIPT",
            url: "/lmsservice/checkermodule/cancelreceipt",
            disabled: true,
          },
          RECEIPT_PART_B: {
            name: "Receipt",
            code: "CHECKER_RECEIPT_PART_B",
            url: "/lmsservice/checkermodule/ReceiptPartB",
            disabled: true,
            children: {
              CASH_RECEIPT: {
                name:"CASH",
                code:"CHK_RECEIPT_CASH_PART_B",
                disabled: true,
              },
              ELECTRONIC_RECEIPT: {
                name:"ELECTRONIC RECEIPT",
                code:"CHK_RECEIPT_ELECTRONIC_PART_B",
                disabled: true,
              },
            },
          },
          CANCEL_RECEIPT_PART_B: {
            name: "Cancel Receipt",
            code: "CHECKER_CANCEL_RECEIPT_PART_B",
            url: "/lmsservice/checkermodule/CancelReceiptPartB",
            disabled: true,
          },
          PAYMENT: {
            name: "Payment",
            code: "CHECKER_PAYMENT",
            url: "/lmsservice/checkermodule/payment",
            disabled: true,
            children:{
              PAYBLE_PAYMENT:{
                name:"Payable",
                code:"CHK_PAYMENT_CASH",
                disabled:true,
              },
              CANCEL_PAYMENT:{
                name:"Cancel",
                code:"CHK_PAYMENT_CANCEL",
                disabled:true,
              },
              Disbursal_PAYMENT:{
                name:"Disbursal",
                code:"CHK_PAYMENT_DISBURSAL",
                disabled:true,
              },
              CHECKER_CROSS_SELL_PAYMENT:{
                name:"Cross Sell",
                code:"CHK_PAYMENT_CROSS_SELL",
                disabled:true,
              },
              CROSS_SELL_PAYMENT:{
                name:"Payment Eligible Loan",
                code:"CHK_PAYMENT_ELIGIBLE",
                disabled:true,
              },
              ONLINE_APPLICATIONS:{
                name:"Online Applications",
                code:"ONLINE_APPLICATIONS_PAYMENT",
                disabled:true,
              },
              KYC_DOCUMENT:{
                name:"KYC Discrepancy",
                code:"KYC_DOCUMENT_APPROVAL",
                disabled:true,
              },
            },
          },
        },
      },
      CHARGES: {
        name: "Charges",
        code: "CHECKER_CHARGES",
        disabled: true,
        children: {
          ENTRY: {
            name: "Entry",
            code: "CHECKER_ENTRY",
            url: "/lmsservice/checkermodule/entry",
            disabled: true,
          },
          CANCELLATION: {
            name: "Cancellation",
            code: "CHECKER_CANCELLATION",
            url: "/lmsservice/checkermodule/Cancellation",
            disabled: true,
          },
          WAIVE_OFF: {
            name: "Waive off",
            code: "CHECKER_WAIVE_OFF",
            url: "/lmsservice/checkermodule/waiveoff",
            disabled: true,
          },
          NEW_WAIVE_OFF: {
            name: "Waive off",
            code: "CHECKER_NEW_WAIVE_OFF",
            url: "/lmsservice/checkermodule/newwaiveoff",
            disabled: true,
          },
           NEW_WAIVE_OFF_CANCEL: {
            name: "Waive off Cancel",
            code: "CHECKER_NEW_WAIVE_OFF_CANCEL",
            url: "/lmsservice/makermodule/newwaiveoffCancel",
            disabled: true,
          },
        },
      },
      ASSET: {
        name: "Asset",
        code: "CHECKER_ASSET",
        disabled: true,
        children: {
          COLLATERAL_OPERATION: {
            name: "Collateral Operation",
            code: "CHECKER_COLLATERAL_OPERATION",
            url: "/lmsservice/checkermodule/CollateralOperation",
            disabled: true,
          },
          BRANCH_KEY_HOLDER: {
            name:"Branch Key Holder",
            code:"CHK_BRANCH_KEY_HOLDER",
            url:"/lmsservice/checkermodule/BankKeyHolderUpdate",
            disabled:true,
          },
          VALUT_UPDATE:{
            name: "Vault Update",
            code:"CHK_VALUT_UPDATE",
            url:"/lmsservice/checkermodule/vaultUpdate",
            disabled:true,
          }
        },
      },
      LOAN_MARKING: {
        name: "Loan Marking",
        code: "CHECKER_LOAN_MARKING",
        disabled: true,
        children: {
          MARKING: {
            name: "Loan Marking",
            code: "CHECKER_MARKING",
            url: "/lmsservice/checkermodule/LoanMarking",
            disabled: true,
          },
          REMOVAL: {
            name: "Removal",
            code: "CHECKER_REMOVAL",
            url: "/lmsservice/checkermodule/Removal",
            disabled: true,
          },
        },
      },
      CLOSURE: {
        name: "Closure",
        code: "CHECKER_CLOSURE",
        disabled: true,
        children: {
          CLOSURE_ACTION: {
            name: "Closure",
            code: "CHECKER_CLOSURE_ACTION",
            url: "/lmsservice/checkermodule/Closure",
            disabled: true,
          },
          CLOSURE_REMOVAL: {
            name: "Closure Removal",
            code: "CHECKER_CLOSURE_REMOVAL",
            url: "/lmsservice/checkermodule/ClosureRemoval",
            disabled: true,
          },
        },
      },
      POST_DISBURSAL_EDIT: {
        name: "Post Disbursal Edit",
        code: "CHECKER_POST_DISBURSAL_EDIT",
        disabled: true,
        children: {
          LOAN_LINKING_DELINKING: {
            name: "Loan Linking/Delinking",
            code: "CHECKER_LOAN_LINKING_DELINKING",
            url: "/lmsservice/checkermodule/loandelinkandlink",
            disabled: true,
            children:{
              CHK_POST_LINKING: {
                name:"Link",
                code:"CHK_POST_LINK",
                disabled:true,
              },
              CHK_POST_DE_LINKING: {
                name:"DeLink",
                code:"CHK_POST_DELINK",
                disabled:true,
              },
            }
          },
          ADDRESS_UPDATE: {
            name: "Address Update",
            code: "CHECKER_ADDRESS_UPDATE",
            url: "/lmsservice/checkermodule/AddressUpdate",
            disabled: true,
          },
          CUSTOMER_UPDATE: {
            name: "Customer Update",
            code: "CHECKER_CUSTOMER_UPDATE",
            url: "/lmsservice/checkermodule/CustomerUpdate",
            disabled: true,
             children:{
              CHK_POST_CUSTOMER_INFO: {
                name:"Customer Info",
                code:"CHK_POST_INFO",
                disabled:true,
              },
              CHK_POST_CUSTOMER_COMMUNICATION: {
                name:"Communications",
                code:"CHK_POST_COMMUNICATION",
                disabled:true,
              },
              CHK_POST_CUSTOMER_MERGE: {
                name:"Customer merge",
                code:"CHK_POST_MERGE",
                disabled:true,
              },
            }
          },
          LOAN_INFO_UPDATE: {
            name: "Loan Info Update",
            code: "CHECKER_LOAN_INFO_UPDATE",
            url: "/lmsservice/checkermodule/Laonupdate",
            disabled: true,
            children:{
              CHK_POST_CYCLE_DATE: {
                name:"Cycle Date",
                code:"CHK_CYCLE_DATE",
                disabled:true,
              },
              CHK_POST_ACCURAL_INTEREST: {
                name:"Accural Interst",
                code:"CHK_POST_ACCURAL_INTEREST",
                disabled:true,
              },
              CHK_POST_SANCTION_LETTER: {
                name:"Sanction Letter",
                code:"CHK_POST_SANCTION_LETTER",
                disabled:true,
              },
              CHK_POST_RECTIFICATION: {
                name:"Rectification",
                code:"CHK_POST_RECTIFICATION",
                disabled:true,
              },
              CHK_POST_ORNAMENT: {
                name:"Ornament Photo",
                code:"CHK_POST_ORNAMENT_PHOTO",
                disabled:true,
              },
             INTEREST_DATE: {
                name:"Interest Date Update",
                code:"CHK_INTESTET_DATE_UPDATE",
                url:"/lmsservice/checkermodule/interestDateUpdate",
                disabled:true,
              },
              CHK_PRINCIPLE_UPDATE: {
                name:"Principle Update",
                code:"CHK_PRINCIPLE_UPDATE",
                disabled:true,
              },
            }
          },
          PACKET_CHANGE: {
            name: "Packet Change",
            code: "CHECKER_PACKET_CHANGE",
            url: "/lmsservice/checkermodule/PacketChange",
            disabled: true,
          },
          REPORT_RECTIFICATION: {
            name: "Scheduler Report Upload",
            code: "CHECKER_SCHEDULAR_REPORT_UPLOAD",
            url: "/lmsservice/checkermodule/reportRectification",
            disabled: true,
          },
        },
      },
      AUCTION: {
        name: "Auction",
        code: "CHECKER_AUCTION",
        disabled: true,
        children: {
          AUCTION_ACTION: {
            name: "Auction",
            code: "CHECKER_AUCTION_ACTION",
            url: "/lmsservice/checkermodule/Auction",
            disabled: true,
          },
        },
      },
      INSTRUMENT_ENTRY: {
        name: "Instrument Entry",
        code: "CHECKER_INSTRUMENT_ENTRY",
        disabled: true,
        children: {
          BANK_DETAILS_UPDATE: {
            name: "Bank Details Update",
            code: "CHECKER_BANK_DETAILS_UPDATE",
            url: "/lmsservice/checkermodule/BankDetailsUpdate",
            disabled: true,
          },
          REPAYMENT_SCHEDULE: {
            name: "Repayment Schedule",
            code: "CHECKER_REPAYMENT_SCHEDULE",
            url: "/lmsservice/checkermodule/RepaymentSchedular",
            disabled: true,
          },
          MANDATE_UPDATE: {
            name: "Mandate Update",
            code: "CHECKER_MANDATE_UPDATE",
            url: "/lmsservice/checkermodule/mandateUpdate",
            disabled: true,
          },
        },
      },
      PDD: {
        name: "PDD",
        code: "CHECKER_PDD",
        disabled: true,
        children: {
          PDD_CREATE: {
            name: "PDD Create",
            code: "CHECKER_PDD_CREATE",
            url: "/lmsservice/checkermodule/Pdd",
            disabled: true,
          },
          PDD_REMOVAL: {
            name: "PDD Removal",
            code: "CHECKER_PDD_REMOVAL",
            url: "/lmsservice/checkermodule/PddRemoval",
            disabled: true,
          },
        },
      },
      VIRTUALACCOUNTCHECKER: {
        name: "Virtual Account",
        code: "CHECKER_VIRTUAL_ACCOUNT",
        url: "/lmsservice/makermodule/virtualAccount",
        disabled: true,
      },
    },
  },
  BULK_PROCESS: {
    name: "Bulk Process",
    code: "BULK_PROCESS",
    disabled: true,
    children: {
      UPLOAD: {
        name: "Upload",
        code: "BULK_PROCESS_UPLOAD",
        disabled: true,
        children: {
          RECEIPT: {
            name: "Receipt",
            code: "BULK_PROCESS_RECEIPT",
            url: "/lmsservice/bulk-uploads/receipt",
            disabled: true,
          },
          RECEIPTNEW: {
            name: "Receipt",
            code: "BULK_PROCESS_RECEIPT_NEW",
            url: "/lmsservice/bulk-uploads/receipt",
            disabled: true,
          },
          MARKING: {
            name: "Marking",
            code: "BULK_PROCESS_MARKING",
            url: "/lmsservice/bulk-uploads/marking",
            disabled: true,
          },
          MARKING_REMOVAL: {
            name: "Marking Removal",
            code: "BULK_PROCESS_MARKING_REMOVAL",
            url: "/lmsservice/bulk-uploads/marking-removal",
            disabled: true,
          },
          CHARGES: {
            name: "Charges",
            code: "BULK_PROCESS_CHARGES",
            url: "/lmsservice/bulk-uploads/charges",
            disabled: true,
          },
          LOAN_CLOSURE: {
            name: "Loan Closure",
            code: "BULK_PROCESS_LOAN_CLOSURE",
            url: "/lmsservice/bulk-uploads/loan-closure",
            disabled: true,
          },
          LOAN_AUCTION: {
            name: "Loan Auction",
            code: "BULK_PROCESS_LOAN_AUCTION",
            url: "/lmsservice/bulk-uploads/auction",
            disabled: true,
          },
          CHARGE_CANCEL: {
            name: "Charge Cancel",
            code: "BULK_PROCESS_CHARGE_CANCEL",
            url: "/lmsservice/bulk-uploads/charge-cancel",
            disabled: true,
          },
          PAYABLE: {
            name: "Payable",
            code: "BULK_PROCESS_PAYABLE",
            url: "/lmsservice/bulk-uploads/payable",
            disabled: true,
          },
          VIRTUAL_ACCOUNT: {
            name: "Virtual Account",
            code: "BULK_PROCESS_VIRTUAL_ACCOUNT",
            url: "/lmsservice/bulk-uploads/virtualAccountBulk",
            disabled: true,
          },
        },
      },
      DOWNLOAD: {
        name: "Download",
        code: "BULK_PROCESS_DOWNLOAD",
        disabled: true,
        children: {
          BULK_LETTER: {
            name: "Bulk Letter",
            code: "BULK_PROCESS_BULK_LETTER",
            url: "/lmsservice/bulkProcess/download/auctionletter",
            disabled: true,
            children: {
              BULK_DOWONLOAD_LETTER: {
                name: "Bulk Letter Download",
                code: "BULK_DOWONLOAD_LETTER",
                url: "/lmsservice/bulkProcess/download/auctionletter",
                disabled: true,
              },
               BULK_DOWNLOAD_DOCUMENTS: {
                name: "Bulk Documents Download",
                code: "BULK_DOWNLOAD_DOCUMENTS",
                url: "/lmsservice/bulkProcess/download/auctionletter",
                disabled: true,
              },
        },
          },
        },
      },
      MIGRATION: {
        name: "Customer Migration",
        code: "BULK_PROCESS_MIGRATION",
        disabled: true,
        children: {
          PROFILE_MIGRATION: {
            name: "Profile Migration",
            code: "BULK_PROCESS_PROFILE_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/profileMigration",
            disabled: true,
          },
           LOAN_DETAILS_MIGRATION: {
            name: "Loan Details Migration",
            code: "BULK_PROCESS_LOAN_DETAILS_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/loanDetailMigration",
            disabled: true,
          },
           ORNAMENT_DETAILS_MIGRATION: {
            name: "Ornament Details Migration",
            code: "BULK_PROCESS_ORNAMENT_DETAILS_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/ornamentDetailsMigration",
            disabled: true,
          },
            PAYABLE_MIGRATION: {
            name: "Payable Migration",
            code: "BULK_PROCESS_PAYABLE_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/payableMigration",
            disabled: true,
          },
          DOCUEMNT_MIGRATION: {
            name: "Document Requirement Migration",
            code: "BULK_PROCESS_LOAN_DOCUMENT_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/loanDocumentMigration",
            disabled: true,
          },
          INSURANCE_MIGRATION: {
            name: "Insurance Migration",
            code: "BULK_PROCESS_LOAN_INSURANCE_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/loanInsuranceMigration",
            disabled: true,
          },
          SECURITY_MIGRATION: {
            name: "Security Migration",
            code: "BULK_PROCESS_LOAN_SECURITY_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/loanSecurityMigration",
            disabled: true,
          },
          PARTICIPANT_MIGRATION: {
            name: "Participant Migration",
            code: "BULK_PROCESS_LOAN_PARTICIPANT_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/loanParticipantMigration",
            disabled: true,
          },
           DOCUMENT_SUBMISSION_MIGRATION: {
            name: "Document Submission Migration",
            code: "BULK_PROCESS_LOAN_DOCUMENT_SUBMISSION_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/loanDocumentSubmissionMigration",
            disabled: true,
          },
          APPROVAL_MIGRATION: {
            name: "Approval Migration",
            code: "BULK_PROCESS_LOAN_APPROVAL_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/loanApprovalMigration",
            disabled: true,
          },
          MANDATE_MIGRATION: {
            name: "Mandate Migration",
            code: "BULK_PROCESS_LOAN_MANDATE_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/mandateMigration",
            disabled: true,
          },
          REPAYMENT_SCHEDULE_MIGRATION: {
            name: "Repayment Schedule Migration",
            code: "BULK_PROCESS_LOAN_REPAYMENT_SCHEDULE_MIGRATION",
            url: "/lmsservice/bulkProcess/customerMigration/repaymentScheduleMigration",
            disabled: true,
          },
        },
      }
    },
  },
  REPORTS: {
    name: "Reports",
    code: "REPORTS",
    disabled: true,
    children: {
      DUMPS_AND_MIS: {
        name: "Dumps and MIS",
        code: "REPORTS_DUMPS_AND_MIS",
        disabled: true,
        children: {
          AUDIT_REPORT: {
            name: "Audit Report",
            code: "REPORTS_AUDIT_REPORT",
            disabled: true,
            children: {
              AUDITED_HISTORY_REPORT: {
                name: "Audited History Report",
                code: "REPORTS_AUDITED_HISTORY_REPORT",
                url: "/lmsservice/Reportmodule/loanAuditedHistoryReports",
                disabled: true,
              },
              AUDITED_LOANS_REPORT: {
                name: "Audited Loans Report",
                code: "REPORTS_AUDITED_LOANS_REPORT",
                url: "/lmsservice/Reportmodule/loanAuditedReports",
                disabled: true,
              },
              AUDITED_TRAIL_REPORT: {
                name: "Audited Trail Report",
                code: "REPORTS_AUDITED_TRAIL_REPORT",
                url: "/lmsservice/Reportmodule/loanAuditedTrailReports",
                disabled: true,
              },
              CASH_BALANCE_DISCREPANCY_REPORT: {
                name: "Cash Balance Discrepancy Report",
                code: "REPORTS_CASH_BALANCE_DISCREPANCY_REPORT",
                url: "/lmsservice/Reportmodule/balanceDiscrepancyReports",
                disabled: true,
              },
              UNAUDITED_LOANS_REPORT: {
                name: "Unaudited Loans Report",
                code: "REPORTS_UNAUDITED_LOANS_REPORT",
                url: "/lmsservice/Reportmodule/OrnamentAuditReport",
                disabled: true,
              },
              LAST_AUDITED_REPORT: {
                name: "Last Audited Report",
                code: "REPORTS_LAST_AUDITED_REPORT",
                url: "/lmsservice/Reportmodule/lastAuditedReport",
                disabled: true,
              },
            },
          },
          ASSET_LOCATION_SCHEDULAR_REPORT: {
            name: "Asset Location Report",
            code: "ASSET_LOCATION_REPORT_SCHEDULAR",
            url: "/lmsservice/Reportmodule/assetLocationReport",
            disabled: true,
          },
          TRANSACTION_LOG: {
            name: "Account Extract",
            code: "REPORTS_TRANSACTION_LOG",
            url: "/lmsservice/Reportmodule/Reports/TransationLog",
            disabled: true,
          },
          AUCTION_CLOSURE_REPORT: {
            name: "Auction Closure Report",
            code: "REPORTS_AUCTION_CLOSURE_REPORT",
            url: "/lmsservice/Reportmodule/auctionClosure",
            disabled: true,
          },
          AUCTION_PROFIT_LOSS_REPORT: {
            name: "Auction Profit & Loss Report",
            code: "REPORTS_AUCTION_PROFIT_LOSS_REPORT",
            url: "/lmsservice/Reportmodule/profitLossReport",
            disabled: true,
          },
          AUCTION_REPORT: {
            name: "Auction Report",
            code: "REPORTS_AUCTION_REPORT",
            url: "/lmsservice/Reportmodule/AuctionReport",
            disabled: true,
          },
          AUDIT: {
            name: "Audit",
            code: "REPORTS_AUDIT",
            url: "/lmsservice/Reportmodule/AuditReport",
            disabled: true,
          },
          AUDITED_MTM_REPORT: {
            name: "Audited MTM Report",
            code: "REPORTS_AUDITED_MTM_REPORT",
            url: "/lmsservice/Reportmodule/AuditedMtmReport",
            disabled: true,
          },
          AUDITED_MIS_REPORT:{
             name: "Audited MIS Report",
            code: "AUDITED_MIS_REPORT",
            url: "/lmsservice/Reportmodule/auditedMisReports",
            disabled: true,
          },
          BRANCH_AUDIT_SUMMARY_REPORT: {
            name: "Branch Audit Summary Report",
            code: "REPORTS_BRANCH_AUDIT_SUMMARY_REPORT",
            url: "/lmsservice/Reportmodule/BranchAuditSummary",
            disabled: true,
          },
          BRANCH_MTM_REPORT: {
            name: "Branch MTM Report",
            code: "REPORTS_BRANCH_MTM_REPORT",
            url: "/lmsservice/Reportmodule/newMtmReport",
            disabled: true,
          },
          BRANCH_PORTFOLIO: {
            name: "Branch Portfolio",
            code: "REPORTS_BRANCH_PORTFOLIO",
            url: "/lmsservice/Reportmodule/BranchPortfolio",
            disabled: true,
          },
          BRANCH_RH: {
            name: "Branch Rh",
            code: "REPORTS_BRANCH_RH",
            url: "/lmsservice/Reportmodule/BranchRh",
            disabled: true,
            children:{
              RH_REAL_TIME_REPORT:{
                name:"Real Time",
                code:"RH_REAL_TIME_REPORT",
                disabled:true,
              },
              RH_SCHEDULER_BASED_REPORT:{
                name:"Schedular Based",
                code:"RH_SCHEDULER_BASED_REPORT",
                disabled:true,
              },
            }
          },
          CHARGE_STATUS_REPORT_SCHEDULAR: {
            name: "Charge Status Report",
            code: "CHARGE_STATUS_REPORT_SCHEDULAR",
            url: "/lmsservice/Reportmodule/ChargeStatusReport",
            disabled: true,
          },
          CIBIL_REPORT: {
            name: "Cibil Report",
            code: "REPORTS_CIBIL_REPORT",
            url: "/lmsservice/Reportmodule/CibilReport",
            disabled: true,
          },
          CLIENT_TRIAL_REPORT: {
            name: "Client Trial Report",
            code: "REPORTS_CLIENT_TRIAL_REPORT",
            url: "/lmsservice/Reportmodule/ClientTrialReport",
            disabled: true,
          },
          CLOSED_LOANS_REPORT: {
            name: "Closed Loans Report",
            code: "REPORTS_CLOSED_LOANS_REPORT",
            url: "/lmsservice/Reportmodule/closedLoans",
            disabled: true,
          },
          COLENDING_RECEIPT_REPORT: {
            name: "Colending Receipt Allocation Report",
            code: "COLENDING_RECEIPT_ALLOCATION_REPORT",
            url: "/lmsservice/Reportmodule/colendingReceiptAllocationReport",
            disabled: true,
          },
          COLLECTION_EFFICIENCY_REPORT: {
            name: "Collection Efficiency Report",
            code: "REPORTS_COLLECTION_EFFICIENCY_REPORT",
            url: "/lmsservice/Reportmodule/CollectionEfficiencyReport",
            disabled: true,
          },
          REPORT_NEGATIVE_REGISTRY: {
            name: "Customer Negative Registry Report",
            code: "REPORT_NEGATIVE_REGISTRY",
            url: "/lmsservice/Reportmodule/negativeRegistryReport",
            disabled: true,
          },
          DEBTOR_REPORT: {
            name: "Debtor Report",
            code: "REPORTS_DEBTOR_REPORT",
            url: "/lmsservice/Reportmodule/DebtorReport",
            disabled: true,
          },
          DISBURSAL_REPORT: {
            name: "Disbursal Report",
            code: "REPORT_DISBURSAL",
            url: "/lmsservice/Reportmodule/disbursalReport",
            disabled: true,
          },
          DISBURSAL_PAYMENT_REPORT: {
            name: "Disbursal Payment",
            code: "DISBURSAL_PAYMENT",
            url: "/lmsservice/Reportmodule/disbursalPayment",
            disabled: true,
          },
          FUTURE_PRINCIPAL: {
            name: "Future Principal",
            code: "REPORTS_FUTURE_PRINCIPAL",
            url: "/lmsservice/Reportmodule/FuturePrincipal",
            disabled: true,
          },
          FUTURE_RECEIVABLE_INTEREST: {
            name: "Future Receivable Interest",
            code: "REPORTS_FUTURE_RECEIVABLE_INTEREST",
            url: "/lmsservice/Reportmodule/FutureReceivableInterest",
            disabled: true,
          },
          HANDS_OFF_FILE: {
            name: "GL Hands-off file",
            code: "REPORTS_HANDS_OFF_FILE",
            url: "/lmsservice/Reportmodule/HandsOffFile",
            disabled: true,
          },
          GST_REPORT: {
            name: "GST Report",
            code: "REPORTS_GST_REPORT",
            url: "/lmsservice/Reportmodule/GstReport",
            disabled: true,
          },
          INSURANCE_REPORT: {
            name: "Insurance Report",
            code: "REPORTS_INSURANCE_REPORT",
            url: "/lmsservice/Reportmodule/InsuranceReport",
            disabled: true,
          },
          INTEREST_DUE_DUMP_REPORT: {
            name: "Interest Due Dump Report",
            code: "REPORTS_INTEREST_DUE_DUMP_REPORT",
            url: "/lmsservice/Reportmodule/interestDueDumpReport",
            disabled: true,
          },
          REACTIFICATION_REPORT: {
            name: "Interest update Report",
            code: "INTEREST_UPDATE_REPORT",
            url: "/lmsservice/Reportmodule/reactificationReport",
            disabled: true,
          },
          IRR_REPORT: {
            name: "IRR Report",
            code: "REPORTS_IRR_REPORT",
            url: "/lmsservice/Reportmodule/irrReport",
            disabled: true,
          },
          KYC_REPORT: {
            name: "KYC Report",
            code: "REPORTS_KYC_REPORT",
            url: "/lmsservice/Reportmodule/kycLoanReport",
            disabled: true,
          },
          LOAN_DOCUMENTS: {
            name: "Loan Documents",
            code: "REPORTS_LOAN_DOCUMENTS",
            url: "/lmsservice/Reportmodule/DumpDocuments",
            disabled: true,
          },
          LOAN_DUMP_REPORT: {
            name: "Loan Dump Report",
            code: "REPORTS_LOAN_DUMP_REPORT",
            url: "/lmsservice/Reportmodule/LoanDumpReport",
            disabled: true,
          },
          M2M_REPORT: {
            name: "M2M Report",
            code: "REPORTS_M2M_REPORT",
            url: "/lmsservice/Reportmodule/MtmReport",
            disabled: true,
          },
          NACH_REPORT: {
            name: "Nach Report",
            code: "NACH_REPORT",
            url: "/lmsservice/Reportmodule/NachReport",
            disabled: true,
          },
          PACKET_AUDIT_REPORT:{
            name: "Packet Audit Report",
            code: "PACKET_AUDIT_REPORT",
            url: "/lmsservice/Reportmodule/packetAuditReports",
            disabled: true,
          },
          PENDING_PAYMENT_REPORT: {
            name: "Pending Payment Report",
            code: "PENDING_PAYMENT_REPORT",
            url: "/lmsservice/Reportmodule/pendingPaymentReport",
            disabled: true,
          },
          PAR_REPORT: {
            name: "PAR Report",
            code: "PAR_REPORT",
            url: "/lmsservice/Reportmodule/parReport",
            disabled: true,
          },
          PARTNER_REPORT: {
            name: "Partner Lead Report",
            code: "PARTNER_LEAD_REPORT",
            url: "/lmsservice/Reportmodule/PartnerLead",
            disabled: true,
          },
          PAYABLE_REPORT: {
            name: "Payable Report",
            code: "REPORTS_PAYABLE_REPORT",
            url: "/lmsservice/Reportmodule/Payable",
            disabled: true,
          },
          SELF_COLENDING_REPORT: {
            name: "Self Colending Report",
            code: "REPORTS_SELF_COLEDING_REPORT",
            url: "/lmsservice/Reportmodule/selfColendingReport",
            disabled: true,
          },
          SHORT_FALL_REPORT: {
            name: "Short Fall Report",
            code: "REPORTS_SHORT_FALL_REPORT",
            url: "/lmsservice/Reportmodule/ShortFallReport",
            disabled: true,
          },
          SUMMARY_REPORT: {
            name: "Summary Report",
            code: "REPORTS_SUMMARY_REPORT",
            url: "/lmsservice/Reportmodule/SummaryReport",
            disabled: true,
          },
          TRANSACTION_LOG_REPORT: {
            name: "Transaction Log Report",
            code: "REPORTS_TRANSACTION_LOG_REPORT",
            url: "/lmsservice/Reportmodule/TransactionLogReport",
            disabled: true,
          },
          TRIAL_BALANCE: {
            name: "Trial Balance",
            code: "REPORTS_TRIAL_BALANCE",
            url: "/lmsservice/Reportmodule/TrialBalance",
            disabled: true,
            children:{
              BR_WISE_TRIAL_BALANCE:{
                name:"Br Wise Trial Balance",
                code:"BR_WISE_TRIAL_BALANCE",
                disabled:true,
              },
              TRIAL_BALANCE_PERIOD:{
                name:"Trial Balance Period",
                code:"TRIAL_BALANCE_PERIOD",
                disabled:true,
              },
              CONSOLIDATED_TRIAL_BALANCE:{
                name:"Consolidated Trial Balance",
                code:"CONSOLIDATED_TRIAL_BALANCE",
                disabled:true,
              },
            }
          },
           UNAUDITED_LOAN_REPORT: {
            name: "UnAudited Loan Report",
            code: "UNAUDITED_LOAN_REPORT",
            url: "/lmsservice/Reportmodule/UnAuditedLoanReport",
            disabled: true,
            children:{
              UNAUDIT_REAL_TIME_REPORT:{
                name:"Real Time",
                code:"UNAUDIT_REAL_TIME_REPORT",
                disabled:true,
              },
              UNAUDIT_SCHEDULER_BASED_REPORT:{
                name:"Schedular Based",
                code:"UNAUDIT_SCHEDULER_BASED_REPORT",
                disabled:true,
              },
            }
          },
          VAULT_ACCESS_REPORT: {
            name: "Vault Access Report",
            code: "REPORTS_VAULT_REPORT",
            url: "/lmsservice/Reportmodule/vaultAccessReport",
            disabled: true,
          },
          VOUCHER_REPORT: {
            name: "Voucher Report",
            code: "REPORTS_VOUCHER_REPORT",
            url: "/lmsservice/Reportmodule/VoucherReport",
            disabled: true,
          },
        },
      },
      BRANCH_REPORTS: {
        name: "Branch Reports",
        code: "REPORTS_BRANCH_REPORTS",
        disabled: true,
        children: {
          ASSET_LOCATION: {
            name: "Asset Location",
            code: "REPORTS_ASSET_LOCATION",
            url: "/lmsservice/Reportmodule/Reports/AssetLocation",
            disabled: true,
          },
          AUDITED_LOANS_REPORT: {
            name: "Audited Loans Report",
            code: "REPORTS_BRANCH_AUDITED_LOANS_REPORT",
            url: "/lmsservice/Reportmodule/loanAuditedReports",
            disabled: true,
          },
          BRANCH_KEY_HOLDER: {
            name: "Branch Key Holder",
            code: "REPORTS_BRANCH_KEY_HOLDER",
            url: "/lmsservice/Reportmodule/Reports/BranchKeyReport",
            disabled: true,
          },
          BRANCH_TRANSACTION: {
            name: "Branch Transaction",
            code: "REPORTS_BRANCH_TRANSACTION",
            url: "/lmsservice/Reportmodule/Reports/BranchTransaction",
            disabled: true,
          },
           BRS: {
            name: "Bank Reconciliation",
            code: "REPORTS_BRS",
            url: "/lmsservice/Reportmodule/Reports/Brs",
            disabled: true,
          },
          BT: {
            name: "BT",
            code: "REPORTS_BT",
            url: "/lmsservice/Reportmodule/Reports/Bt",
            disabled: true,
          },
          CASH_BOOK: {
            name: "Cash Book",
            code: "REPORTS_CASH_BOOK",
            url: "/lmsservice/Reportmodule/Reports/CashBook",
            disabled: true,
          },
          COLLATERAL: {
            name: "Collateral",
            code: "REPORTS_COLLATERAL",
            url: "/lmsservice/Reportmodule/Reports/Collateral",
            disabled: true,
          },
          DISBURSAL: {
            name: "Disbursal",
            code: "REPORTS_DISBURSAL",
            url: "/lmsservice/Reportmodule/Reports/DisbursalMis",
            disabled: true,
          },
          INTEREST_DUE: {
            name: "Interest Due",
            code: "REPORTS_INTEREST_DUE",
            url: "/lmsservice/Reportmodule/Reports/InterestDueMis",
            disabled: true,
          },
          INTEREST_RECEIVED: {
            name: "Interest Received",
            code: "REPORTS_INTEREST_RECEIVED",
            url: "/lmsservice/Reportmodule/Reports/InterestReceived",
            disabled: true,
          },
          LOAN_CLOSE_DUMP: {
            name: "Loan Close Dump",
            code: "REPORTS_LOAN_CLOSE_DUMP",
            url: "/lmsservice/Reportmodule/Reports/LoanDump",
            disabled: true,
          },
          PART_PAYMENT: {
            name: "Part Payment",
            code: "REPORTS_PART_PAYMENT",
            url: "/lmsservice/Reportmodule/Reports/PartPayment",
            disabled: true,
          },
          PRE_AUCTION: {
            name: "Pre Auction",
            code: "REPORTS_PRE_AUCTION",
            url: "/lmsservice/Reportmodule/Reports/PreAuctionReport",
            disabled: true,
          },
          RECEIPT_ALLOCATION: {
            name: "Receipt Allocation",
            code: "REPORTS_RECEIPT_ALLOCATION",
            url: "/lmsservice/Reportmodule/Reports/ReceiptAllocation",
            disabled: true,
          },
          TENURE_EXPIRY: {
            name: "Tenure Expiry",
            code: "REPORTS_TENURE_EXPIRY",
            url: "/lmsservice/Reportmodule/Reports/TenureExpiry",
            disabled: true,
          },
        },
      },
    },
  },
  lmsMasters: {
    name: "LMS Masters",
    code: "LMS_MASTERS",
    disabled: true,
    url: "",
    children: {
      commonSetups: {
        name: "Common Setups",
        code: "COMMON_SETUPS",
        disabled: true,
        url: "",
        children: {
          reason: {
            name: "Reason",
            code: "REASON",
            disabled: true,
            url: "/lmsservice/LMSMastermodule/Reason",
          },
          charge: {
            name: "Charge",
            code: "CHARGE",
            disabled: true,
            url: "/lmsservice/LMSMastermodule/Charge",
          },
          agency: {
            name: "Agency",
            code: "AGENCY",
            disabled: true,
            url: "/lmsservice/LMSMastermodule/agency",
          },
          bidder: {
            name: "Bidder",
            code: "BIDDER",
            disabled: true,
            url: "/lmsservice/LMSMastermodule/bidder",
          },
        },
      },
    },
  },
  auditModule: {
    name: "Audit Module",
    code: "AUDIT_MODULE",
    disabled: true,
    url: "",
    children: {
      ornamentAudit: {
        name: "Ornament Audit",
        code: "ORNAMENT_AUDIT",
        disabled: true,
        url: "/lmsservice/Auditmodule/Audit",
      },
      registerAudit: {
        name: "Register Audit",
        code: "REGISTER_AUDIT",
        disabled: true,
        url: "/lmsservice/Auditmodule/Register",
      },
      noticeAudit: {
        name: "Notice Board Audit",
        code: "NOTICE_AUDIT",
        disabled: true,
        url: "/lmsservice/Auditmodule/Notice",
      },
      packetAudit: {
        name: "Packet Audit",
        code: "PACKET_AUDIT",
        disabled: true,
        url: "/lmsservice/Auditmodule/PacketAndLoanModal",
        children:{
          AUDIT_PACKET_COUNT:{
            name:"Packet Count",
            code:"AUDIT_PACKET_COUNT",
            disabled:true,
          },
          AUDIT_PACKET_INSPECTION:{
            name:"Packet Inventory",
            code:"AUDIT_PACKET_INSPECTION",
            disabled:true,
          }
        }
      },
      cashDetailsAudit: {
        name: "Cash Denomination Audit",
        code: "CASH_DETAILS_AUDIT",
        disabled: true,
        url: "/lmsservice/Auditmodule/CashDetails",
      },
      documentAudit: {
        name: "Document Audit",
        code: "DOCUMENT_AUDIT",
        disabled: true,
        url: "/lmsservice/Auditmodule/loanDocument",
      },
    },
  },
  auction: {
    name: "Auction",
    code: "AUCTION",
    disabled: true,
    url: "",
    children: {
      auctionProcess: {
        name: "Auction Process",
        code: "AUCTION_PROCESS",
        disabled: true,
        url: "/lmsservice/auction/auctionProcess",
        children:{
          AUCTION_PROCESS:{
            name:"Auction Process",
            code:"AUCTION_PROCESS_BULK",
            disabled:true,
          },
          AUCTION_REPORT:{
            name:"Auction Loan Wise Process",
            code:"AUCTION_LOAN_WISE_PROCESS",
            disabled:true,
          }
        }
      },
      auctionReport: {
        name: "Auction Report",
        code: "AUCTION_REPORT",
        disabled: true,
        url: "/lmsservice/auction/auctionReport",
      },
    },
  },
  bulkDownload: {
    name: "Bulk Download",
    code: "BULK_DOWNLOAD",
    disabled: true,
    url: "",
    children: {
      auctionLetter: {
        name: "Auction Letter",
        code: "AUCTION_LETTER",
        disabled: true,
        url: "/lmsservice/bulkDownload/auctionletter",
      },
    },
  },
  schedular: {
    name: "Schedular",
    code: "SCHEDULAR",
    disabled: true,
    url: "",
    children: {
      schedularReport: {
        name: "Schedular Report",
        code: "SCHEDULAR_REPORT",
        disabled: true,
        url: "/lmsservice/schedular/report",
      },
      schedularList:{
        name:"Schedular List",
        code:"SCHEDULAR_LIST",
        disabled:true,
        url:"/lmsservice/schedular/schedularList"
      }
    },
  },
  dailyCashBalance: {
    name: "Daily Cash Balance",
    code: "DAILY_CASH_BALANCE",
    disabled: true,
    url: "/lmsservice/daily/balance",
  },
};


export const accessTableColumnsCounts ={
  lms:[5, 2, 10],
  core:[11,11,15],
  los:[2,2,5]
}

export const lendingPartner = {
  tableColumns:[ { id: "name", label: "Partner Name" },
    { id: "partnerCode", label: "Partner Code" },
    {id: "self", label:"Self Status"},
    { id: "status", label: "Status" },
    {id:"action", label:"Action"},
  ],
    label:"Lending Partner",
    searchLabel:"Search For Lending Partner",
    buttonCreate:"Create",
    deleteMessage:"Lending Partner deleted is successfully",
    confirmationMsg:"Are you sure you want to delete this entry",
    confirmationHdr:"Lending Partner",
    updateMsg:"Lending Partner updated successfully!",
    createMsg:"Lending Partner created successfully!",
    title1:"Create Lending Partner",
    title2:"Edit Lending Partner"
}

export const lendingPartnerDeal = {
  tableColumns:[ 
    { id: "code", label: "Partner Deal Code" },
    {id:"partnerCode", label:"Partner Code"},
    { id: "name", label: "Partner Deal Name" },
    {id: "type", label:"Product Type"},
    { id: "status", label: "Status" },
    {id:"action", label:"Action"}],
    label:"Lending Partner Deal",
    searchLabel:"Search For Lending Partner Deal",
    buttonCreate:"Create",
    deleteMessage:"Lending Partner Deal deleted is successfully",
    confirmationMsg:"Are you sure you want to delete this entry",
    confirmationHdr:"Lending Partner Deal",
    updateMsg:"Lending Partner Deal updated successfully!",
    createMsg:"Lending Partner Deal created successfully!",
    title1:"Create Lending Partner Deal",
    title2:"Edit Lending Partner Deal"
}

export const lendingPartnerDealShare = {
  tableColumns:[ 
    { id: "name", label: "Partner Deal Name" },
    {id: "type", label:"Type"},
    { id: "code", label: "Partner Deal Code" },
    {id:"percentage", label:"Percentage"},
    {id:"disbursal", label:"Is Disbursal"},
    { id: "status", label: "Status" },
    {id:"action", label:"Action"}],
    label:"Lending Partner Deal Share",
    searchLabel:"Search For Lending Partner Deal Share",
    buttonCreate:"Create",
    deleteMessage:"Lending Partner Deal Share deleted is successfully",
    confirmationMsg:"Are you sure you want to delete this entry",
    confirmationHdr:"Lending Partner Deal Share",
    updateMsg:"Lending Partner Deal Share updated successfully!",
    createMsg:"Lending Partner Deal Share created successfully!",
    title1:"Create Lending Partner Deal Share",
    title2:"Edit Lending Partner Deal Share"
}

export const productDealShareType = [
  { "code": "ADHOC", "name": "Adhoc Charge" },
  { "code": "ADVERTISEMENT", "name": "Advertisement Charge" },
  { "code": "ANNUAL_ROI", "name": "Annual Roi"},
  { "code": "AUCTION", "name": "Auction Charge" },
  { "code": "AUCTIONEER", "name": "Auctioneer Charge" },
  { "code": "BOUNCE_CHEQUE", "name": "Bounce Charge" },
  { "code": "CASH_DISBURSAL", "name": "Cash Disbursal Charge" },
  { "code": "CLOSURE", "name": "Closure Charge" },
  { "code": "CUSTODY", "name": "Custody Charge" },
  { "code": "DELIVERABLE", "name": "Deliverable Charge" },
  { "code": "DISBURSAL", "name": "Disbursal"},
  { "code": "FORCLOSURE", "name": "Forclosure Charge" },
  { "code": "INSURANCE", "name": "Insurance Charge" },
  { "code": "LOAN_CANCELLATION", "name": "Loan Cancellation Charge" },
  { "code": "MEMO", "name": "Memo Charge" },
  { "code": "OTHER", "name": "Other Charge" },
  { "code": "PAWN_TICKET_REPRINT", "name": "Pawn Ticket Reprint Charge" },
  { "code": "PENALTY", "name": "Penalty Charge" },
  { "code": "PENAL_CHARGE_LTV", "name": "Penal Ltv Charge" },
  { "code": "PENAL_CHARGE_NON_PAYMENT", "name": "Penal Non Payment Charge" },
  { "code": "POSTAL", "name": "Postal Charge" },
  { "code": "PREPAYMENT", "name": "Prepayment Charge" },
  { "code": "PRINTING", "name": "Printing Charge" },
  { "code": "PROCESSING_FEE", "name": "Processing Fee Charge" },
  { "code": "SORTING_AND_AUCTION", "name": "Sorting And Auction Charge" },
  { "code": "STAMPDUTY", "name": "Stamp Duty Charge" },
  { "code": "TRAVELLING", "name": "Travelling Charge" }
];

export  const packetAllocationTableColumns = [
    { id: "branch", label: "Branch" },
    { id: "branchName", label: "Branch Name" },
    { id: "packetSize", label: "Packet Size" },
    { id: "from", label: "Series Start" },
    { id: "to", label: "Series End" },
    { id: "weight", label: "Packet Weight" },
    { id: "action", label: "Actions" },
  ];
export  const packetHOAllocationTableColumns = [
    { id: "packetSize", label: "Packet Size" },
    { id: "from", label: "Series Start" },
    { id: "to", label: "Series End" },
    { id: "weight", label: "Packet Weight" },
    { id: "action", label: "Actions" },
  ];
export  const stateTableColumns = [
    { id: "code", label: "State Code" },
    { id: "name", label: "State Name" },
    { id: "gst", label: "GST Number" },
    { id: "gstCode", label: "GST Code" },
    { id: "cgst", label: "SGST(%)" },
    { id: "sgst", label: "CGST(%)" },
    { id: "igst", label: "IGST(%)" },
    { id: "language", label: "Language" },
    { id: "action", label: "Action" },
  ];
  export const packetSizes = [
    { code: "3.0*3.0", name: "3.0*3.0" },
    { code: "3.0*6.0", name: "3.0*6.0" },
    { code: "6.0*3.0", name: "6.0*3.0" },
    { code: "6.0*6.0", name: "6.0*6.0" },
    { code: "10.0*6.5", name: "10.0*6.5" },
  ];

export const collaterealEvaluationTableColumns = [
    { id: "role", label: "Role" },
    { id: "branch", label: "Branch Name" },
    { id: "designation", label: "Designation Code" },
    { id: "min", label: "Min Amount" },
    { id: "max", label: "Max Amount" },
    { id: "level", label: "Level" },
    { id: "applicationSubType", label: "Application Sub Type" },
    { id: "action", label: "Actions" },
  ]

  export const previewDealSharetableColumns = [ 
    { id: "name", label: "Partner Deal Name" },
    {id: "type", label:"Type"},
    { id: "code", label: "Partner Deal Code" },
    {id:"percentage", label:"Percentage"},
    {id:"disbursal", label:"Is Disbursal"},
  ]

  export const schemeChannelOptions = [
      {
        code: "APP_TOPUP",
        name: "App Topup",
      },
      {
        code: "NEW",
        name: "New"
      }
    ];

  export const sourceOptions = [
      {
        code: "WEB",
        name: "Web",
        disabled: false,
      },
      {
        code: "MOBILE",
        name: "Mobile",
        disabled: false,
      },
    ];
  
  export const typeOptions =[
      {
        code: "TOPUP",
        name: "Top-Up",
        disabled: false,
      },
      {
        code: "RENEWAL",
        name: "Renewal",
        disabled: false,
      },
    ]

export const designationTableColumns = [
  { id: "designation", label: "Designation" },
  { id: "name", label: "Level" },
  { id: "action", label: "Actions" },
]
    export const deviationDataConfig = {
  label: "Deviation",
  button: "Deviation Create",
  searchLabel: "Search For Deviation",
  createUrl: "/coreservice/deviation-create",
  viewUrl: "/coreservice/deviation-createview/",
  updateUrl: "/coreservice/deviation-createview/",
  confirmationHeader: "Deviation",
  confirmationMsg: "Are you sure you want to delete this entry",
  successMsg: "Deviation master deleted successfully",
  tableColumns: [
    { id: "code", label: "Code" },
    { id: "ruleType", label: "Rule Type" },
    { id: "unit", label: "Unit" },
    { id: "designation", label: "Designation" },
    { id: "level", label: "Level" },
    { id: "minValue", label: "Minimum Value" },
    { id: "maxValue", label: "Maximum Value" },
    { id: "status", label: "Status" },
    { id: "actions", label: "Actions" },
  ],
  createSuccess:"Deviation master created successfully",
  mainUrl:"/coreservice/deviation",
  editLabel:"Edit Deviation",
  updateUser:"Deviation master updated successfully"
};

export const deviationRuleCode = [
  { code: "LTV_CHANGE", name: "Ltv Percentage Change" },
  { code: "ROI_CHANGE", name: "Roi Percentage Change" },
  { code: "AGE_ISSUE", name: "Age Issue" },
  { code: "FI_NEGATIVE_HO", name: "FI Negative HO" },
  { code: "EMPLOYEE_LOAN", name: "Employee Loan" },
  { code: "ADDRESS_ISSUE", name: "Address Issue" },
  { code: "NAME_MISMATCH", name: "Name Mismatch" },
  { code: "CIBIL_ISSUE", name: "Cibil Issue" },
  { code: "GROSS_WEIGHT_MISMATCH", name: "Gross Weight Percentage Mismatch" },
  { code: "CUSTOMER_COL_WEIGHT_KG", name: "Customer Col Weight Kg" },
  { code: "GEO_LIMIT", name: "Geo Limit" },
];

export const deviationRuleTypelist = [
  { code: "RANGE", name: "Range" },
  { code: "BOOLEAN", name: "Boolean" },
  { code: "ENUM", name: "Enum" },
];

export const deviationUnitTypelist = [
  { code: "PERCENTAGE", name: "Percentage" },
  { code: "KG", name: "Kg" },
  { code: "FLAG", name: "Flag" },
  { code: "YEARS", name: "Years" },
  { code: "SCORE", name: "Score" },
];

export const deviationRuleUnitMap = {
  LTV_CHANGE: {
    ruleType: "RANGE",
    unit: "PERCENTAGE",
  },
  ROI_CHANGE: {
    ruleType: "RANGE",
    unit: "PERCENTAGE",
  },
  AGE_ISSUE: {
    ruleType: "RANGE",
    unit: "YEARS",
  },
  FI_NEGATIVE_HO: {
    ruleType: "BOOLEAN",
    unit: "FLAG",
  },
  EMPLOYEE_LOAN: {
    ruleType: "BOOLEAN",
    unit: "FLAG",
  },
  ADDRESS_ISSUE: {
    ruleType: "BOOLEAN",
    unit: "FLAG",
  },
  NAME_MISMATCH: {
    ruleType: "BOOLEAN",
    unit: "FLAG",
  },
  CIBIL_ISSUE: {
    ruleType: "RANGE",
    unit: "SCORE",
  },
  GROSS_WEIGHT_MISMATCH: {
    ruleType: "RANGE",
    unit: "PERCENTAGE",
  },
  CUSTOMER_COL_WEIGHT_KG: {
    ruleType: "RANGE",
    unit: "KG",
  },
  GEO_LIMIT: {
    ruleType: "RANGE",
    unit: "SCORE",
  },
};

export const leadValidationvalue = [
  { code: "maxNetWeightPercentage", name: "Max Net Weight Percentage" },
]

export const leadValidationColumns = [
  { id: "code", label: "Id" },
  { id: "name", label: "Validation Name" },
  { id: "validationValue", label: "Validation Value" },
  { id: "status", label: "Status"},
  { id: "action", label: "Actions" },
];

export const chargeNatureList = [
    { code: "FLAT", name: "Flat" },
    { code: "PERCENTAGE", name: "Percentage" },
  ]

  export const chargesNameList = {
    processingFee: "PROCESSING_FEE",
    penalChargeNonPayment:"PENAL_CHARGE_NON_PAYMENT"
  }

  export const particularDesignationAccess = ["MAIN USER"]

export const negativeRegistryTableColumns =   [
    { id: "name", label: "Name" },
    { id:"pan", label:"Pan Number"},
    { id:"uid", label:"Aadhar Number"},
    { id:"mobileNumber", label:"Mobile Number"},
    { id:"risk", label: "Risk"},
    { id:"reason", label:"Reason"},
    { id: "action", label: "Actions" },
  ];

 export const negativeRegistryFileColumns = [
        "Name",
        "Pan Number",
        "Aadhar Number",
        "Mobile Number",
        "Risk",
        "Reason"
  ];

export  const masterCategoryColumns = [
  { id: "index", label: "S. No." },
  { id: "name", label :"Name"},
  { id: "description", label: "Description" },
  { id: "action", label: "Actions"}
];
export  const masterCategoryItemColumns = [
  { id: "index", label: "S. No." },
  { id: "categoryId", label :"Category Name"},
  { id: "value", label: "Value" },
  { id: "action", label: "Actions" }
];

export const masterCategory = [
  {code:"SOURCE_OF_REPAYMENT_OF_LOAN", name:"Source of Repayment of Loan"},
  {code:"DOCUMENT_LIST", name:"Document list"},
]

  export const collateralTypeList = [
    { code: "JEWELLERY", name: "Jewellery" },
    { code: "ORNAMENTS", name: "Ornaments" },
    { code: "COINS", name: "Coins" }
  ]

  export const productTypeNames = {
    personalLoan:"Personal Loan",
  }

export const loanTypeList=[
    {value: "NEW" , label:"New" },
    {value: "TOP_UP" , label:"TopUp"},
    {value: "PART_RELEASE" , label:"Part Release"},
    {value: "RENEWAL" , label:"Renew" },
    {value: "POST_PLEDGE" , label:"Bt PostLedge" },
]

export  const CustomerTypeList = [
  { code: "NEW", name: "New Customer" },
  { code: "OLD", name: "Existing Customer" },
  { code: "BOTH", name: "Both Customer" },
  ];

export const getNewCustomerValue = (customerType) => {
  switch (customerType) {
    case "NEW":
      return true;
    case "OLD":
      return false;
    case "BOTH":
    default:
      return null;
  }
};

export const getCustomerType = (newCustomer) => {
  switch (newCustomer) {
    case true:
      return "NEW";
    case false:
      return "OLD";
    case null:
    default:
      return "BOTH";
  }
};

export  const tenureTypeList = [
  { code: "DAYS", name: "Days" },
  { code: "MONTH", name: "Month" },
  ];

export const durationUnits = {
  DAYS: "DAYS",
  MONTH: "MONTH",
}


export const personalLoanLosList = {
  applications: {
    name: "Applications",
    code: "APPLICATIONS",
    disabled: true,
    children: {
      inProcess: {
        name: "In Process",
        code: "INPROCESS",
        url: "/AdminPortal",
        disabled: true,
      },
      approved: {
        name: "Approved",
        code: "APPROVED",
        url: "/AdminPortal",
        disabled: true,
      },
      submitted: {
        name: "Submitted",
        code: "SUBMITTED",
        url: "/AdminPortal",
        disabled: true,
      },
      repaymentSchedule: {
        name: "Repayment Schedule",
        code: "LEAD_REPAYMENT_SCHEDULE",
        url: "/AdminPortal",
        disabled: true,
      },
      sanctionEsign: {
        name: "Sanction Esign",
        code: "LEAD_SANCTION_ESIGN",
        url: "/AdminPortal",
        disabled: true,
      },
      completed: {
        name: "Completed",
        code: "COMPLETED",
        url: "/AdminPortal",
        disabled: true,
      },
      rejected: {
        name: "Rejected",
        code: "REJECTED",
        url: "/AdminPortal",
        disabled: true,
      },
    },
  },
  rejectApplication: {
    name: "Reject Application",
    code: "REJECT_APPLICATION",
    url: "/rejectApplication",
    disabled: true,
  },
  leadAssignment: {
    name: "Lead Assignement",
    code: "LEAD_ASSIGNED",
    url: "/leadAssign",
    disabled: true,
  },
};